import { render } from "./LoanHistory.vue?vue&type=template&id=906e103e"
import script from "./LoanHistory.vue?vue&type=script&lang=js"
export * from "./LoanHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__